var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3139({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 4.5,
    stroke: "#747BA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 26C23.671 26 25 24.669 25 23C25 21.331 23.671 20 22 20C20.329 20 19 21.331 19 23C19 24.669 20.329 26 22 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.817 21.186C30.5814 20.0344 30.1209 18.9405 29.462 17.967C28.8146 17.0093 27.9897 16.1844 27.032 15.537C26.0584 14.8783 24.9646 14.4179 23.813 14.182C23.2081 14.0593 22.5922 13.999 21.975 14.002V12L18 15L21.975 18V16.002C22.459 16 22.943 16.046 23.41 16.142C24.305 16.3254 25.1552 16.6832 25.912 17.195C26.6584 17.6982 27.3008 18.3406 27.804 19.087C28.5853 20.2422 29.002 21.6054 29 23C28.9998 23.9359 28.8128 24.8623 28.45 25.725C28.2735 26.1405 28.0579 26.5383 27.806 26.913C27.5531 27.2854 27.2659 27.6332 26.948 27.952C25.98 28.9182 24.7511 29.5809 23.412 29.859C22.4807 30.047 21.5213 30.047 20.59 29.859C19.6946 29.6754 18.844 29.3173 18.087 28.805C17.3415 28.3022 16.6998 27.6605 16.197 26.915C15.4166 25.7585 14.9997 24.3952 15 23H13C13.0011 24.7937 13.5369 26.5463 14.539 28.034C15.1868 28.9901 16.0109 29.8142 16.967 30.462C18.4526 31.4675 20.2061 32.0033 22 32C22.6093 31.9999 23.217 31.9386 23.814 31.817C24.9647 31.5794 26.0579 31.1191 27.032 30.462C27.5103 30.1397 27.956 29.7717 28.363 29.363C28.7705 28.9544 29.1388 28.5084 29.463 28.031C30.4676 26.5458 31.0031 24.7931 31 23C30.9999 22.3907 30.9386 21.783 30.817 21.186Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3139);
export default __webpack_public_path__ + "static/media/Group 3139.89f5f15cfd39224cf61f66a86304f6b9.svg";
export { ForwardRef as ReactComponent };